export { default as Img200 } from './processed/200/Picnic-At-Hanging-Rock-S1.jpg';
export { default as Img400 } from './processed/400/Picnic-At-Hanging-Rock-S1.jpg';
export { default as Imgthumb } from './processed/thumb/Picnic-At-Hanging-Rock-S1.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Picnic-At-Hanging-Rock-S1.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Picnic-At-Hanging-Rock-S1.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      209,
      10,
      131
    ],
    "_population": 1454,
    "_hsl": [
      0.8986599664991625,
      0.908675799086758,
      0.4294117647058823
    ]
  },
  "LightVibrant": {
    "_rgb": [
      231,
      170,
      146
    ],
    "_population": 285,
    "_hsl": [
      0.04705882352941176,
      0.6390977443609022,
      0.7392156862745098
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      24,
      83,
      129
    ],
    "_population": 473,
    "_hsl": [
      0.5730158730158731,
      0.6862745098039216,
      0.3
    ]
  },
  "Muted": {
    "_rgb": [
      167,
      86,
      85
    ],
    "_population": 171,
    "_hsl": [
      0.0020325203252032735,
      0.3253968253968254,
      0.49411764705882355
    ]
  },
  "LightMuted": {
    "_rgb": [
      220,
      191,
      177
    ],
    "_population": 416,
    "_hsl": [
      0.054263565891472874,
      0.3805309734513276,
      0.7784313725490196
    ]
  },
  "DarkMuted": {
    "_rgb": [
      51,
      69,
      95
    ],
    "_population": 1563,
    "_hsl": [
      0.5984848484848485,
      0.30136986301369867,
      0.28627450980392155
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Picnic-At-Hanging-Rock-S1.js